export default {
    // $ 公共
    general_button_cancel: 'Cancelar',
    general_button_sure: 'Confirmar',
    general_button_close: 'Fechar',
    general_text_update_faild: 'Não foi possível atualizar',
    general_button_done: 'Feito',
    general_text_no_data: 'Nenhum dado encontrado',
    general_text_ordered: 'Pedido',
    general_text_next_turn_time: 'Turno',
    general_text_get_limit_rule_failed: 'Não foi possível obter as regras do turno',
    general_text_customer_not_exist: 'O usuário {{n}} não existe',
    general_text_can_not_get_rules_of_dish: 'Não foi possível obter os dados do prato',

    // $ 历史订单
    order_history_page_text_no_make: 'Não foi feito',
    order_history_page_text_make_complete: 'Em entrega',
    order_history_page_text_service_complete: 'Servido',
    order_history_page_text_unable_make: 'Cancelado',
    order_history_page_text_pause_make: 'Suspenso',
    order_history_page_text_waiter: 'Garçom',
    order_history_page_text_customer: 'Cliente',
    order_history_page_text_extra: 'Taxa adicional',
    order_history_page_text_order_devices: 'Outros dispositivos',
    history_order_you: 'Cliente',
    history_order_round: 'A rodada {{round}}',
    history_order_total: 'total: {{number}} pratos',

    // $ 呼叫服务
    service_page_text_call_service_select: 'Chamar serviço (opcional)',
    service_page_text_insert_texts: 'Escreva o conteúdo (opcional)',
    service_page_text_call_waiter: 'Chamar garçom',
    service_page_text_call_service: 'Chamar serviço',
    service_page_text_table_name: 'Nome da mesa',
    service_page_text_Please_select_a_service: 'Selecione um serviço',
    service_page_text_Your_requirement: 'Solicitação (facultativo)',
    service_page_text_call_service_success_message: 'Chamada bem-sucedida',
    service_page_input_placeholder_message: 'Digite sua solicitação...',

    // $ 购物车
    order_cart_page_text_total: 'Total',
    order_cart_page_text_complete_order: 'Você completou o pedido deste turno',
    order_cart_page_text_round_max_order_count: 'Limite de pedidos do turno: {{n}}',
    order_cart_page_text_round_max_number_exceed: 'Limite de pedidos superado',
    order_cart_page_text_similar_dish_number_exceed: 'Limite da categoria superado',
    order_cart_page_text_same_dish_number_exceed: 'Limite de pedidos deste prato superado',
    order_cart_page_text_max_rounds_exceed: 'Limite do turno superado',
    order_cart_page_text_dish_not_exists: 'O prato não existe',
    order_cart_page_text_commit_cart_fail: 'Não foi possível enviar ao carrinho',
    order_cart_page_text_commit_success: 'Enviado',
    order_cart_page_text_cart_not_data: 'Nenhum dado',
    order_cart_page_text_select_preferences: 'Clique no nome do prato para escolher o tempero ou molho',
    order_cart_page_text_disable_edit_second: 'Após {{s}} segundos passará ao próximo turno',
    order_cart_page_text_print_credential_fail: 'Erro de impressão',
    order_cart_page_text_dish_remarks: 'Notas dos pratos',
    order_cart_page_text_self: 'Self',
    order_cart_page_text_cannot_at_the_same_time: 'Não envie ou modifique os itens do carrinho contemporaneamente',
    order_cart_page_text_is_submitting: 'Enviando pedido...',
    order_cart_page_text_round_rules: 'Pode enviar uma vez por turno. Você ainda tem uma quantidade sem utilizar. Tem certeza que quer enviar?',
    order_cart_page_text_clear: 'Esvaziar',
    order_cart_page_text_delete: 'Cancelar',
    order_cart_page_text_exe_dishes_commit: 'Há pratos extras se você continuar enviando',
    order_cart_page_text_confirm_modification: 'Confirme',
    order_cart_page_text_sync_round_info_success: 'O turno foi atualizado com sucesso',
    order_cart_page_text_dish_is_sold_out: 'Este prato está esgotado.',
    order_cart_page_text_sold_out: 'Esgotado',
    order_cart_Page_text_verify_sold_out_dishes_message: 'O prato \'{{menuName}}\' está disponível em quantidade de {{excessedNum}}.',

    // $ 点餐
    menu_page_text_please_select_your_id: 'Insira o ID',
    menu_page_text_check_tip_id: 'Esqueceu o ID? Veja o histórico dos pedidos para recuperá-lo',
    menu_page_text_dishes_copy: '{{n}} foi pedido {{1}} vez/es neste turno',
    menu_page_text_more_than_half_ordered: '{{n}} pessoas já pediram {{dish}}',
    menu_page_text_not_show: 'Não mostrar mais esta mensagem',
    menu_page_text_under_review_wait: 'Em revisão, espere um momento',
    menu_page_text_order_success_created_jump: 'O pedido foi criado, vá à página do menú',
    menu_page_text_order_does_not_exist: 'O pedido não existe ou a mesa foi reconfigurada, reabrir',
    menu_page_text_review_rejected: 'Revisão recusada',
    menu_page_text_under_review: 'Em revisão',
    menu_page_text_locked_state: 'O pedido foi bloqueado, pode dar uma olhada no menú de novo',
    menu_page_text_reset_send: 'Pedido de revisão',
    menu_page_text_reset_send_success: 'Solicitação aceita',
    menu_page_text_approved: 'Aprovado',
    menu_page_text_order_unlocked: 'O pedido foi desbloqueado',
    menu_page_text_table_invalid: 'Mesa não válida',
    menu_page_text_customer_id_occupy: 'O ID já está em uso',
    menu_page_text_dish_time_disable: 'Alguns menús foram desabilitados por causa do fechamento da cozinha',
    menu_page_text_notice_time: 'A cozinha vai fechar daqui a {{time}} minutos. Faça seu pedido antes do fechamento da cozinha',
    menu_page_text_allergen_filter_label_message: 'Selecione os pratos a serem filtrados',
    menu_page_text_allergen: 'Alérgenos',
    menu_page_text_ingredents: 'Outras etiquetas de prato',
    menu_page_text_ingredent_filter_label_message: 'Selecione os pratos a serem filtrados',
    menu_page_text_filter: 'Filtro',
    menu_page_text_dish_exceeded: 'Este prato superou o limite de quantidade para este item. Ao continuar, custos extras podem ser debitados',

    // $ 扫码入口页
    home_page_text_please_select_menu: 'Selecione o menú',
    home_page_text_number_of_adults: 'Número de adultos',
    home_page_text_number_of_child: 'Número de crianças',
    home_page_text_adult_price: 'Preço adultos',
    home_page_text_child_price: 'Preço crianças',
    home_page_text_normal: 'Padrão',
    home_page_text_special: 'Especial',
    home_page_text_table_pause_use: 'Mesa não disponível',
    home_page_text_order_now: 'Peça agora',
    home_page_text_get_menu_fail: 'Não foi possível carregar o menú, tente de novo',
    home_page_text_announcement: 'Notificação',

    // $ 公告页
    notice_page_text_no_picture: 'Nenhuma imagem',

    // $ 过敏源种类
    text_gluten: "Glúten",
    text_crustaceans: "Crustáceos",
    text_eggs: "Ovos",
    text_fish: "Peixe",
    text_peanuts: "Amendoim",
    text_soya: "Soja",
    text_milk: "Leite",
    text_tree_nuts: "Nozes",
    text_celery: "Salsão",
    text_mustard: "Mostarda",
    text_sesame: "Gergelim",
    text_sulphites: "Sulfitos",
    text_lupin: "Tremoços",
    text_molluscs: "Moluscos",
    text_mild_spicy: "Um pouco picante",
    text_medium_spicy: "Médio picante",
    text_very_spicy: "Picante",
    text_frozen_origin: "Congelado",
    text_blast_freezing: "Ultracongelado",
    text_vegetarian: "Vegetariano",
    text_vegan: "Vegano",
    text_gluten_free: "Glúten free",
    text_raw: "Crú",
    text_cooked: "Cozido",
    text_additives: "Aditivos",
    text_colourants: "Colorantes",

    // 新手引导
    novice_guide_text_select_menu: 'Selecione o menú',
    novice_guide_text_select_normal_menu: 'Selecione um menú padrão',
    novice_guide_text_select_special_menu: 'Selecione um menú especial',
    novice_guide_text_select_number_of: 'Escolha o número de convidados',
    novice_guide_text_order: 'Pedir',
    novice_guide_text_announcement: 'Notificação',
    novice_guide_text_cart: 'Carrinho',
    novice_guide_text_history: 'Histórico',
    novice_guide_text_call: 'Chamar serviço',
    novice_guide_text_switch_dish_mode: 'Mudar a visualização do menú',
    novice_guide_text_first_menu: 'Selecione o menú principal',
    novice_guide_text_switch_user: 'Mostrar o usuário atual',
    novice_guide_text_round_dish: 'Verificar o número do turno',
    novice_guide_text_click_dish_card_add: 'Clique nesta área para pedir os pratos',
    novice_guide_text_click_dish_card_reduce: 'Clique nesta área para remover pratos',
    novice_guide_text_enlarge_dish_card: 'Clique nesta área para ver os detalhes do prato',
    novice_guide_text_click_cancel: 'Clique para sair do tutorial',
    novice_guide_text_reduce_order: 'Reduzir o pedido',
    novice_guide_text_increase_order: 'Aumentar o pedido',
    novice_guide_text_table: 'Mesa',
    novice_guide_text_enter_number: 'Insira o número de convidados',
    novice_guide_text_swipe_to_switch: 'Arraste para mudar',
    novice_guide_text_home: 'Início',

    // 自助开台
    auto_open_page_text_featured_dishes: 'Especialidades',
    auto_open_page_text_order_now: 'Pedir',
    auto_open_page_text_opening_hours: 'Horários disponíveis para pedir',
    auto_open_page_text_media: 'Redes Sociais',
    auto_open_page_text_website: 'Site oficial',
    auto_open_page_text_reservation: 'Reservar',
    auto_open_page_text_takeaway: 'Takeaway',
    auto_open_page_text_without_menu: 'Nenhum menú habilitado agora',
    auto_open_page_adults: 'Adultos',
    auto_open_page_other: 'Outros',
    auto_open_page_children: 'Crianças',
    auto_open_page_text_menu: 'Menú',
    text_persons: 'Clientes',
    auto_open_page_open_table: 'Abrir mesa',
    auto_open_page_select: 'Selecionar',
    auto_open_page_see_more: 'Ver mais',
    auto_open_page_text_disabled_message: 'A abertura das mesas de autoatendimento está desativada, favor entrar em contato com a equipe.',

    // 临时密码功能
    auto_open_page_text_set_temporary_password: 'Criar um PIN temporário',
    auto_open_page_text_input_temporary_password: 'Insira o PIN',
    auto_open_page_text_reset_temporary_password: 'Reimpostar PIN',
    auto_open_page_text_cancel_temporary_password: 'Eliminar PIN',
    auto_open_page_text_forgot_password: 'Esqueci o PIN',
    auto_open_page_text_input_password: 'Insira um numero de 4 cifras',
    auto_open_page_text_go_back: 'Voltar',
    auto_open_page_text_confirm_changes: 'Confirmar',
    auto_open_page_incorrect_pin: 'PIN errado',
    auto_open_page_modification_failed: 'Não foi possível modificar',
    auto_open_page_modification_succeed: 'Modificado com sucesso',
    auto_open_page_button_confirm: 'Confirmar',
    auto_open_page_employee_account: 'Usuário',
    auto_open_page_employee_password: 'Password',
    auto_open_page_pin: 'PIN',

    // 复合型营业时间
    general_text_all_day_business: 'Aberto 24 horas',
    general_text_business_hours: "Horário de abertura",
    general_text_compound_business_hours: "Horário comercial periódico",

    // 餐厅区域
    general_text_You_are_not_in_the_restaurant_area_unable_to_order: 'Você não está na área do restaurante, impossível pedir',
    general_text_Getting_your_location_failed: 'Não foi possível obter sua localização corretamente',

    general_text_poor_network: 'Não foi possível conectar ao servidor ou rede instável, tente novamente mais tarde',

    // 点餐 - 套餐相关
    menu_page_text_setMenu: 'Menu',
    menu_page_text_choose_the_products: 'Selecione os produtos',
    menu_page_text_add_to_cart: 'Adicionar ao carrinho',
    menu_page_text_set_menu_required: 'Necessário',
}